import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Bell } from 'lucide-react';

export const NotificationPopup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const notifTitle = searchParams.get('notif_title');
    const notifBody = searchParams.get('notif_body');

    if (notifTitle || notifBody) {
      setTitle(notifTitle || 'Notification');
      setBody(notifBody || '');
      setOpen(true);

      // Clean up URL params
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('notif_title');
      newParams.delete('notif_body');
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
              <Bell className="h-5 w-5 text-primary" />
            </div>
            <DialogTitle className="text-lg">{title}</DialogTitle>
          </div>
          <DialogDescription className="text-sm pt-2 leading-relaxed">
            {body}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end pt-2">
          <Button onClick={() => setOpen(false)} size="sm">
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
